enum TrusteeTypeEnum {
    Company = 'COMPANY',
    Individual = 'INDIVIDUAL',
}

export default TrusteeTypeEnum;
